/* Vacances Bonifacio — countdown banner */
(function () {
  if (window.__vbCountdownBannerLoaded) return;
  window.__vbCountdownBannerLoaded = true;

  function pad(n) {
    return String(n).padStart(2, '0');
  }

  function initCountdown() {
    var banners = document.querySelectorAll('[data-vb-countdown]');
    if (!banners.length) return;

    banners.forEach(function (banner) {
      var deadlineValue = banner.getAttribute('data-deadline') || '2026-06-01T00:00:00+02:00';
      var deadline = new Date(deadlineValue).getTime();

      var daysEl = banner.querySelector('[data-vb-days]');
      var hoursEl = banner.querySelector('[data-vb-hours]');
      var minutesEl = banner.querySelector('[data-vb-minutes]');
      var secondsEl = banner.querySelector('[data-vb-seconds]');

      function tick() {
        var now = Date.now();
        var diff = Math.max(0, deadline - now);

        var days = Math.floor(diff / 86400000);
        var hours = Math.floor((diff % 86400000) / 3600000);
        var minutes = Math.floor((diff % 3600000) / 60000);
        var seconds = Math.floor((diff % 60000) / 1000);

        if (daysEl) daysEl.textContent = pad(days);
        if (hoursEl) hoursEl.textContent = pad(hours);
        if (minutesEl) minutesEl.textContent = pad(minutes);
        if (secondsEl) secondsEl.textContent = pad(seconds);
      }

      tick();
      setInterval(tick, 1000);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initCountdown);
  } else {
    initCountdown();
  }
})();
